import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { dayjs } from "@/utils/dayjs";
import { Dayjs } from "dayjs";
import { Box, FormHelperText } from "@mui/material";
import { useState, useCallback } from "react";
import { getFeeDateErrorMessage } from "@/features/management-ledger/components/FeeLedgerEditableCells";

export type TUpdateValidPeriodDraft = (talentId: number, value: string) => void;

type TProps = {
    row: {
        talentId: number;
    };
    value: string;
    isEditing: boolean;
    showValidationError?: boolean;
    onChange: TUpdateValidPeriodDraft;
};

export const LedgerValidPeriodEditableCell = ({ row, value, isEditing, showValidationError = false, onChange }: TProps) => {
    const [isTouched, setIsTouched] = useState(false);
  const label = "有効期間";
  const rawError = getFeeDateErrorMessage(value, label);
    const showError = rawError && (value === "Invalid Date" || isTouched || showValidationError);
    const errorMessage = showError ? rawError : undefined;

    const handleChange = useCallback((next: Dayjs | null) => {
        setIsTouched(true);
        onChange(row.talentId, next ? next.format("YYYY-MM-DD") : "");
    }, [onChange, row.talentId]);

    const handleBlur = useCallback(() => {
        setIsTouched(true);
    }, []);

    if (!isEditing) {
        return <span>{value}</span>;
    }
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: 33, position: "relative", width: "100%" }}>
            <InputDatePicker
                nonControl
                value={value ? dayjs(value) : null}
                error={Boolean(errorMessage)}
                onChange={handleChange}
                onBlur={handleBlur}
                disableHelperText
            />
            {Boolean(errorMessage) && (
                <FormHelperText error sx={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: 0, marginLeft: "4px", lineHeight: 1.2, whiteSpace: "pre-line", zIndex: 1, backgroundColor: "white" }}>
                    {errorMessage}
                </FormHelperText>
            )}
        </Box>
    );
};
